import PortalVue from 'portal-vue'

export default {
  install(app) {
    app.use(PortalVue)
  },
}
